const craftTitle = (clinic, base_name ) => {
  var title = base_name;
  if(clinic.overrides && clinic.overrides.page_title) {
    title += clinic.overrides.page_title;
  } else {
    title += ` | Dental clinic in ${clinic.city}, ${clinic.state}`;
  }
  return title;
}

export const dynamicTitle = (clinic, base_name) => {
var title = craftTitle(clinic, base_name);
title = title ? title : 'Home';
window.document.title = title;
};

export const setDescription = desc => {
  const el = document.querySelector("meta[name='description']");
  el.setAttribute('content',desc);
}

export const setKeywords = keywords => {
  const el = document.querySelector("meta[name='keywords']");
  el.setAttribute('content', keywords);
}

export const get_request_option = (method, json) => {
    return {
      method: method,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json, text/plain, */*' },
      body: json,
    }
}

export const getToday = () => {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth()+1;
  var yyyy = today.getFullYear();
  if(dd<10){
    dd='0'+dd
  }
  if(mm<10){
    mm='0'+mm
  }
  return  yyyy+'-'+mm+'-'+dd;
}

const parseHex = (hex) => {
  let value = (hex || '').replace(/[#;\s]/g, '');
  if(!/^([0-9a-f]{3}|[0-9a-f]{6})$/i.test(value)) {
    return null;
  }
  if(value.length === 3) {
    value = value.split('').map(c => c + c).join('');
  }
  return [0, 2, 4].map(i => parseInt(value.substr(i, 2), 16));
}

const luminance = (rgb) => {
  const [r, g, b] = rgb.map(c => {
    c = c / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

const toHex = (rgb) => '#' + rgb.map(c => c.toString(16).padStart(2, '0')).join('');

// Deepens a theme colour (keeping its hue) until white text on it reaches 4.5:1 contrast.
// `extra` darkens further, e.g. for the second stop of a gradient.
export const deepTone = (hex, extra = 0) => {
  const rgb = parseHex(hex);
  if(!rgb) {
    return '#1f2937';
  }
  const ink = [11, 18, 32];
  const mix = (amount) => rgb.map((c, i) => Math.round(c + (ink[i] - c) * amount));
  let amount = 0.3;
  while(amount < 0.9 && (1.05 / (luminance(mix(amount)) + 0.05)) < 4.5) {
    amount += 0.05;
  }
  return toHex(mix(Math.min(amount + extra, 0.95)));
}

// Theme colour with transparency, e.g. for soft tinted backgrounds.
export const withAlpha = (hex, alpha) => {
  const rgb = parseHex(hex);
  if(!rgb) {
    return `rgba(31, 41, 55, ${alpha})`;
  }
  return `rgba(${rgb.join(', ')}, ${alpha})`;
}

// WCAG contrast ratio between two colours, or null if either is invalid.
export const contrastRatio = (hexA, hexB) => {
  const a = parseHex(hexA);
  const b = parseHex(hexB);
  if(!a || !b) {
    return null;
  }
  const [light, dark] = [luminance(a), luminance(b)].sort((x, y) => y - x);
  return (light + 0.05) / (dark + 0.05);
}

// Readable text/accent colours for a surface whose background is configured per clinic
// (e.g. to match the logo), so it may be white, light, mid-tone or dark.
export const surfacePalette = ({ background, foreground, primary }) => {
  const bg = parseHex(background) ? '#' + (background || '').replace(/[#;\s]/g, '') : '#ffffff';
  const ink = '#111827';
  // dark surfaces get white text; decided by whichever reads better on this background
  const is_dark = contrastRatio('#ffffff', bg) > contrastRatio(ink, bg);
  const pick = (candidates, minimum) => candidates.find(c => (contrastRatio(c, bg) || 0) >= minimum) || candidates[candidates.length - 1];
  const foreground_ok = (contrastRatio(foreground, bg) || 0) >= 4.5;
  let text, accent;
  if(is_dark) {
    text = foreground_ok ? foreground.replace(/[;\s]/g, '') : 'rgba(255, 255, 255, 0.82)';
    accent = '#ffffff';
  } else {
    text = foreground_ok ? foreground.replace(/[;\s]/g, '') : pick(['#4b5563', '#374151', ink], 4.5);
    accent = pick([primary, deepTone(primary), deepTone(primary, 0.3), ink].filter(c => parseHex(c)), 3);
  }
  return {
    isDark: is_dark,
    bg: bg,
    text: text,
    heading: is_dark ? '#ffffff' : ink,
    muted: is_dark ? 'rgba(255, 255, 255, 0.62)' : pick(['#6b7280', '#4b5563', '#374151'], 4.5),
    accent: accent,
    tint: is_dark ? 'rgba(255, 255, 255, 0.10)' : withAlpha(primary, 0.10),
    border: is_dark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(17, 24, 39, 0.08)',
  };
}

// The clinic's brand colour, darkened only if needed so accents stay visible on white cards
// (at least 3:1 against white). Readable colours are returned unchanged.
export const readableOnWhite = (hex) => {
  const clean = parseHex(hex) ? '#' + (hex || '').replace(/[#;\s]/g, '') : null;
  const candidates = clean ? [clean, deepTone(clean), deepTone(clean, 0.3)] : [];
  return candidates.find(c => (contrastRatio(c, '#ffffff') || 0) >= 3) || '#111827';
}
